import { render, staticRenderFns } from "./InventoryNotes.vue?vue&type=template&id=a06a0c74&scoped=true"
import script from "./InventoryNotes.vue?vue&type=script&lang=js"
export * from "./InventoryNotes.vue?vue&type=script&lang=js"
import style0 from "./InventoryNotes.vue?vue&type=style&index=0&id=a06a0c74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06a0c74",
  null
  
)

export default component.exports